module.exports = __webpack_public_path__ + "static/media/NC-MX5.9f98be30.webp";